<template>
    <div class="window-wrapper" v-show="visible">
        <div class="window map-name-edit-window" >
            <div class="window-head">
                <div class="title">Переименовать карту
                    <span class="close"
                          @click="closeWindow"><img src="@/image/close.png"></span>
                </div>
            </div>
            <div class="window-body">
                <form action="">
                    <input type="text" v-model="newName">
                </form>
                <div class="center two-buttons">
                    <button class="button blue-button" type="button"
                            :disabled="!editAllowed"
                            @click="sendEditRequest">Сохранить
                    </button>
                    <button class="button normal-button" type="button"
                            @click="closeWindow">Отмена
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import utils from '@/utils';

    export default {
        name: "EditAstroMapWindow",

        props: ['visible', 'id', 'name'],

        data() {
            return {
                newName: ''
            }
        },

        watch: {
            visible(val) {
                utils.changePopupWindowVisibility(val);
            },

            name(val) {
                this.newName = val;
            }
        },

        computed: {
            editAllowed() {
                return !!this.newName;
            }
        },

        methods: {
            async sendEditRequest() {
                if (!this.editAllowed)
                    return;

                let success = await this.$store.dispatch('changeAstroMapName', [Number(this.id), this.newName || '']);
                if (success)
                    this.$emit('close-window', {
                        reload: true
                    });
            },

            closeWindow() {
                this.$emit('close-window', {
                    reload: false
                });
            }
        },

        destroyed() {
            utils.changePopupWindowVisibility(false);
        }
    }
</script>